"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var DoctorHero_1 = require("../components/DoctorHero/DoctorHero");
var targetNode = document.querySelector('.doctor-hero-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(DoctorHero_1.default, null), targetNode);
}
